export default __webpack_public_path__ + "static/team-javante-9b62a25c2691cce112ee036cf5881d6d.png";